import { DbService } from "app/services/db/dbService";
import { ResponseResultCode } from "app/model/response-api";
import { MouseEvent, useEffect, useState } from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";
import DashboardLoading from "app/pages/db/modules/DashboardLoading";
import useInterval from "app/hooks/use-interval";

interface ComplexInfoMd {
  emksIndsCmplxClCd: string;
  re100Label: number;
  totalQnt: number;
  genQnt: number;
  joinEntQnt: number;
}

const initOne: ComplexInfoMd = {
  emksIndsCmplxClCd: '1단지', re100Label: 0, totalQnt: 0, genQnt: 0, joinEntQnt: 0,
};
const initTwo: ComplexInfoMd = {
  emksIndsCmplxClCd: '2단지', re100Label: 0, totalQnt: 0, genQnt: 0, joinEntQnt: 0,
};
const initFour: ComplexInfoMd = {
  emksIndsCmplxClCd: '4단지', re100Label: 0, totalQnt: 0, genQnt: 0, joinEntQnt: 0,
};
const initFive: ComplexInfoMd = {
  emksIndsCmplxClCd: '5단지', re100Label: 0, totalQnt: 0, genQnt: 0, joinEntQnt: 0,
};

export default function DbComplexMap() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [one, setOne] = useState<ComplexInfoMd>(initOne);
  const [two, setTwo] = useState<ComplexInfoMd>(initTwo);
  const [four, setFour] = useState<ComplexInfoMd>(initFour);
  const [five, setFive] = useState<ComplexInfoMd>(initFive);

  useEffect(() => {
    fetch();
  }, []);

  useInterval(() => {
    fetch();
  }, 600000);

  function fetch() {
    DbService.getInstance().getStatistics()
    .then(response => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        setOne(convertDataToComplexInfoMd(response.data, '1단지'));
        setTwo(convertDataToComplexInfoMd(response.data, '2단지'));
        setFour(convertDataToComplexInfoMd(response.data, '4단지'));
        setFive(convertDataToComplexInfoMd(response.data, '5단지'));
      } else {
        setOne(initOne);
        setTwo(initTwo);
        setFour(initFour);
        setFive(initFive);
      }
    })
    .catch(() => {
      setOne(initOne);
      setTwo(initTwo);
      setFour(initFour);
      setFive(initFive);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  function convertDataToComplexInfoMd(data: any[], complex: string): ComplexInfoMd {
    let re100: number = 0;
    let total: number = 0;
    let gen: number = 0;
    let ent: number = 0;

    const com = data?.find((f: any) => complex === f.emksIndsCmplxClCd);
    if (com) {
      re100 = com.re100Label ?? 0;
      total = com.totalQnt ?? 0; 
      gen = com.genQnt ?? 0;
      ent = com.joinEntQnt ?? 0;
    }

    return {
      emksIndsCmplxClCd: complex,
      re100Label: re100,
      totalQnt: total,
      genQnt: gen,
      joinEntQnt: ent,
    };
  }

  function handleClickActiveComplex(event: MouseEvent, complex: string) {
    event.preventDefault();
    navigate('/pdcs/engusestatus', { state: { complx: complex } });
  }

  return (
    <div className="cont pd0 cont-x-scrl h100">
      <DashboardLoading isLoading={isLoading} />
      <div className="map-admin">
        <strong className="total-figure">산단 RE100현황</strong>
        <a className="map-complex1 active"
          style={{ cursor: 'pointer' }}
          onClick={(e) => handleClickActiveComplex(e, 'INDS001')}
        >
          <span className="hid">1단지</span>
          <div className="map-complex-box1">
            <strong>
              <strong>1단지</strong>
              <em>RE {Math.floor(one.re100Label)}</em>
            </strong>
            <div>
              <span className="arr"></span>
              <ul className="count-info-lst1">
                <li>
                  <span>한국전력</span>
                  <em>
                    <CountUp end={one.totalQnt - one.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh
                  </em>
                </li>
                <li>
                  <span>신재생</span>
                  <em>
                    <CountUp end={one.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh</em>
                </li>
                {/*<li>*/}
                {/*  <span>참여기업</span>*/}
                {/*  <em>*/}
                {/*    <CountUp end={one.joinEntQnt}>*/}
                {/*      {({ countUpRef }) => <strong ref={countUpRef} />}*/}
                {/*    </CountUp>*/}
                {/*    개</em>*/}
                {/*</li>*/}
              </ul>
            </div>
          </div>
        </a>
        <a className="map-complex2 active"
          style={{ cursor: 'pointer' }}
          onClick={(e) => handleClickActiveComplex(e, 'INDS002')}
        >
          <span className="hid">2,3단지</span>
          <div className="map-complex-box2">
            <strong>
              <strong>2,3단지</strong>
              <em>RE {Math.floor(two.re100Label)}</em>
            </strong>
            <div>
              <span className="arr"></span>
              <ul className="count-info-lst1">
                <li>
                  <span>한국전력</span>
                  <em>
                    <CountUp end={two.totalQnt - two.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh
                  </em>
                </li>
                <li>
                  <span>신재생</span>
                  <em>
                    <CountUp end={two.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh</em>
                </li>
                {/*<li>*/}
                {/*  <span>참여기업</span>*/}
                {/*  <em>*/}
                {/*    <CountUp end={two.joinEntQnt}>*/}
                {/*      {({ countUpRef }) => <strong ref={countUpRef} />}*/}
                {/*    </CountUp>*/}
                {/*    개</em>*/}
                {/*</li>*/}
              </ul>
            </div>
          </div>
        </a>
        <a className="map-complex3 active"
          style={{ cursor: 'pointer' }}
          onClick={(e) => handleClickActiveComplex(e, 'INDS004')}
        >
          <span className="hid">4단지</span>
          <div className="map-complex-box4">
            <strong>
              <strong>4단지</strong>
              <em>RE {Math.floor(four.re100Label)}</em>
            </strong>
            <div>
              <span className="arr"></span>
              <ul className="count-info-lst1">
                <li>
                  <span>한국전력</span>
                  <em>
                    <CountUp end={four.totalQnt - four.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh
                  </em>
                </li>
                <li>
                  <span>신재생</span>
                  <em>
                    <CountUp end={four.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh</em>
                </li>
                {/*<li>*/}
                {/*  <span>참여기업</span>*/}
                {/*  <em>*/}
                {/*    <CountUp end={four.joinEntQnt}>*/}
                {/*      {({ countUpRef }) => <strong ref={countUpRef} />}*/}
                {/*    </CountUp>*/}
                {/*    개</em>*/}
                {/*</li>*/}
              </ul>
            </div>
          </div>
        </a>
        <a className="map-complex4 active"
          style={{ cursor: 'pointer' }}
          onClick={(e) => handleClickActiveComplex(e, 'INDS005')}
        >
          <span className="hid">5단지</span>
          <div className="map-complex-box5">
            <strong>
              <strong>5단지</strong>
              <em>RE {Math.floor(five.re100Label)}</em>
            </strong>
            <div>
              <span className="arr"></span>
              <ul className="count-info-lst1">
                <li>
                  <span>한국전력</span>
                  <em>
                    <CountUp end={five.totalQnt - five.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh
                  </em>
                </li>
                <li>
                  <span>신재생</span>
                  <em>
                    <CountUp end={five.genQnt} decimals={1}>
                      {({ countUpRef }) => <strong ref={countUpRef} />}
                    </CountUp>
                    MWh</em>
                </li>
                {/*<li>*/}
                {/*  <span>참여기업</span>*/}
                {/*  <em>*/}
                {/*    <CountUp end={five.joinEntQnt}>*/}
                {/*      {({ countUpRef }) => <strong ref={countUpRef} />}*/}
                {/*    </CountUp>*/}
                {/*    개</em>*/}
                {/*</li>*/}
              </ul>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}